export const EVENT_NAME = {
  ALL_SELECTION_REMOVED: "All Selections Removed",
  BET_AMOUNT_SELECTED: "Bet Amount Selected",
  BET_SUBMIT: "Bet Submitted"
};

export const MODULE = "Bet Modal";
